import React from "react";
import AppRoot from "screen/00_Nav/app_root";
import { App, ConfigProvider } from "antd";
import { pdfjs } from "react-pdf";
import { getThemes } from "util/theme";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";

const url = `//cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;
pdfjs.GlobalWorkerOptions.workerSrc = url;

const theme = getThemes().theme1;

const MyApp = () => {
  return (
    <ConfigProvider theme={theme}>
      <App>
        <AppRoot />
      </App>
    </ConfigProvider>
  );
};

export default MyApp;
